<template>
  <RevDialog :name="MODAL_NAME" :title="i18n(translations.modalTitle)">
    <template #body="{ close }">
      <div class="my-24 text-center">
        <picture>
          <RevIllustrationSource
            :height="360"
            media="(min-width: 360px)"
            src="/img/onboarding/founders_image_desktop.png"
            :width="640"
          />
          <RevIllustration
            :alt="i18n(translations.imageAlt)"
            :height="1800"
            src="/img/onboarding/founders_image_mobile.png"
            :width="320"
          />
        </picture>
      </div>
      <div class="heading-1 my-24">{{ i18n(translations.modalBodyTitle) }}</div>
      <div class="body-1 my-24">
        {{ i18n(translations.modalBodyDescription1) }}
      </div>
      <div class="body-1 my-24">
        {{ i18n(translations.modalBodyDescription2) }}
      </div>
      <RevButton
        class="mb-20"
        full-width="always"
        variant="primary"
        @click="close"
      >
        {{ i18n(translations.getStartedButton) }}
      </RevButton>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { useCookie, useRoute } from '#imports'
import { onMounted } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'
import { openModal } from '@ds/components/ModalBase'

import {
  COOKIE_WELCOME_SELLER_NAME,
  MINUTES_COUNTER_WITHOUT_MODAL_IN_MS,
  MODAL_NAMES,
  REGISTERED_PARAM_VALUE,
} from './WelcomeSellerModal.constants'
import translations from './WelcomeSellerModal.translations'

const MODAL_NAME = MODAL_NAMES.WELCOME_SELLER

const i18n = useI18n()
const { query } = useRoute()
const cookieRef = useCookie(COOKIE_WELCOME_SELLER_NAME, {
  expires: new Date(new Date().getTime() + MINUTES_COUNTER_WITHOUT_MODAL_IN_MS),
})

onMounted(() => {
  if (!cookieRef.value && query.registered === REGISTERED_PARAM_VALUE) {
    openModal(MODAL_NAME)
    cookieRef.value = 'true'
  }
})
</script>
